import { memo } from "react";
import DashboardDesktop from './Desktop/DashboardDesktop';
const DashboardFile = () => {
    return (
        <>
            <DashboardDesktop />
        </>
    )
}
export default memo(DashboardFile);